module.exports = __webpack_public_path__ + "img/m.943c2f76.jpg";